import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e2db3bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog profile-dialog" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "field" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "btn red" }

import devices from '@/store/device';
import i18, { State as I18State } from '@/store/i18';
import user from '@/store/user';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit: emits }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const store = useStore();
const i18Data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18Data.value.texts[i18Data.value.lang.list[i18Data.value.lang.now]].login)

const state = reactive({
    newPassword: '',
    againPassword: ''
})


async function onSubmit() {
    if (!state.newPassword) {
        return devices.toast(store, lang.value.password_placeholder)
    }
    if (!state.againPassword) {
        return devices.toast(store, lang.value.again_placeholder)
    }
    if (state.newPassword != state.againPassword) {
        return devices.toast(store, lang.value.password_again_wrong)
    }
    try {
        await user.updatePassword(store, state.newPassword)
        devices.toast(store, lang.value.set_success)
        emits('close')
    } catch (e: any) {
        devices.toast(store, e.message)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "close icon i-guanbi c-thirdary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(lang).set_password), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).newPassword) = $event)),
        type: "password",
        placeholder: _unref(lang).password_placeholder
      }, null, 8, _hoisted_4), [
        [_vModelText, _unref(state).newPassword]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).againPassword) = $event)),
        type: "password",
        placeholder: _unref(lang).again_placeholder
      }, null, 8, _hoisted_6), [
        [_vModelText, _unref(state).againPassword]
      ])
    ]),
    _createElementVNode("div", {
      class: "submit",
      onClick: onSubmit
    }, [
      _createElementVNode("a", _hoisted_7, _toDisplayString(_unref(lang).do_ok), 1)
    ])
  ]))
}
}

})